import { useEffect, useState } from "react";

export default function DefaultParam({ param, onChange }) {
  const [_default, setDefault] = useState("");

  useEffect(() => {
    if (param.default) {
      setDefault(param.default);
    }
  }, [param]);

  const onBlur = () => {
    const _param = { ...param };
    _param.default = _default;
    onChange(_param);
  };
  return (
    <div
      style={{
        display: "flex",
        marginTop: 8,
        marginBottom: 8,
        alignItems: "center",
      }}
    >
      <div>{param.name} </div>
      <input
        style={{ maxWidth: 300, marginLeft: 8 }}
        onBlur={onBlur}
        className={"input"}
        value={_default}
        onChange={(e) => setDefault(e.target.value)}
      />
    </div>
  );
}
